import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { QuestionSetModel } from 'src/app/models/questionSetModel';
import { EncrDecrService } from 'src/app/services/EncrDecr.service';
import { CommonService } from 'src/app/services/common/common.service';
import { SharedService } from 'src/app/services/shared.service';
import { QuestionSetConstant } from 'src/app/constants/label-constants';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeleteDialogboxComponent } from '../delete-dialogbox/delete-dialogbox.component';
import { QuestionSetViewComponent } from './question-set-view/question-set-view.component';
import { QuestionSetAddEditComponent } from './question-set-add-edit/question-set-add-edit.component';
import { StatusDialogboxComponent } from '../status-dialogbox/status-dialogbox.component';
import { CommonConstant, NoRecordFound } from 'src/app/constants/common-constant';
import { commonErrorMessage } from 'src/app/constants/error-message-constant';

@Component({
  selector: 'app-question-set',
  templateUrl: './question-set.component.html',
  styleUrls: ['./question-set.component.scss']
})
export class QuestionSetComponent {
  QuestionList: any = [];
  closeResult = '';
  enterSearch: string = '';
  searchClose: boolean = false;
  SortColumn: any = '';
  sortDirection: any = '';
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  showData: boolean = false;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  displayedColumns: string[] = ['rowNumber', 'questionSetName', 'totalQuestion', 'isActive', 'Action'];
  dataSource: MatTableDataSource<QuestionSetModel> = new MatTableDataSource();
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  isSubmitted: boolean = false;
  navigateFlag: boolean = false;
  FileUpload!: File;
  submitted: boolean = false;
  questionSetStutusObj: any = {};
  questionSetDeleteObj: any = {};
  CommonConstant: any = [];
  NoRecordFound: any = [];
  QuestionSetConstant: any = [];
  commonErrorMessage: any = [];

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  constructor(
    public commonService: CommonService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private sharedService: SharedService,
    private router: Router,
    private EncrDecr: EncrDecrService,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.CommonConstant = CommonConstant;
    this.NoRecordFound = NoRecordFound;
    this.QuestionSetConstant = QuestionSetConstant;
    this.getQuestionSetList();
    this.sharedService.setData('Question Set');
    this.commonErrorMessage = commonErrorMessage;
  }

  getQuestionSetList() {
    this.showData = false;
    const objData = {
      PageNumber: this.currentPage + 1,
      PageSize: this.pageSize,
      StrSearch: this.enterSearch,
      SortColumn: this.SortColumn,
      SortOrder: this.sortDirection
    }
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.QuestionSet.GetList;
    this.commonService.doPost(apiUrl, objData).pipe().subscribe({
      next: async (response) => {
        this.spinner.hide();
        if (response.success) {
          this.spinner.hide();
          this.showData = true;
          let TotalRecords = 0;
          this.QuestionList = response.data
          this.dataSource.data = this.QuestionList;
          if (this.QuestionList.length > 0) {
            TotalRecords = this.QuestionList[0].totalRecords;
            this.totalRows = TotalRecords;
          }
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = TotalRecords;
          });
        }
        else {
          this.spinner.hide();
        }
      },
      error: (error) => {
        this.spinner.hide();
      }
    });
  }

  pageChanged(event: { pageSize: number; pageIndex: number; }) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getQuestionSetList();
  }

  SortChange(event: { direction: string; active: any; }) {
    this.sortDirection = event.direction == '' ? 'asc' : event.direction;
    this.SortColumn = event.active;
    this.getQuestionSetList();
  }

  search(event) {
    if (event.target.value == '') {
      this.enterSearch = '';
      this.currentPage =0;
      this.getQuestionSetList();
      this.searchClose = false;
    }
    else {
      this.searchClose = true;
    }
    if (event.key === "Enter" && event.target.value != '') {
      this.currentPage =0;
      this.enterSearch = event.target.value;
      this.getQuestionSetList();
      this.searchClose = true;
    }
  }

  cancelSearch(): void {
    this.enterSearch = '';
    this.getQuestionSetList();
    this.searchClose = false;
  }

  sanitizeInput(event: any) {
    const inputElement: HTMLInputElement = event.target;
    const sanitizedValue: string = inputElement.value.replace(/\D/g, '');
    inputElement.value = sanitizedValue;
  }

  AddQuestionset(questionSetId: number) {
    const modalRef = this.modalService.open(QuestionSetAddEditComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.QuestionSetId = questionSetId;
    modalRef.result.then((result) => {
      if (result === 'save') {
        this.getQuestionSetList();
      }
    }).catch((error) => {
    });
  }

  QuestionsetListDetail(questionSetId: number) {
    const modalRef = this.modalService.open(QuestionSetViewComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.QuestionSetId = questionSetId;
    modalRef.result.then((result) => {
    }).catch((error) => {
    });
  }

  Deletepopup(questionSetId: number, questionSetName: string) {
    const modalRef = this.modalService.open(DeleteDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
    this.questionSetDeleteObj = {
      questionSetId: questionSetId,
      questionSetName: questionSetName,
      element: 'question set'
    }
    modalRef.componentInstance.questionSetDeleteObj = this.questionSetDeleteObj;
    modalRef.result.then((result) => {
      if (result === 'delete') {
        this.getQuestionSetList();
      }
    }).catch((error) => {
    });
  }

  onStatus(questionSetId: number, questionSetName: string, active: boolean) {
    const modalRef = this.modalService.open(StatusDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
    this.questionSetStutusObj = {
      questionSetId: questionSetId,
      questionSetName: questionSetName,
      activequestionSet: active
    }
    modalRef.componentInstance.questionSetStutusObj = this.questionSetStutusObj;
    modalRef.result.then((result) => {
      if (result === 'status') {
        this.QuestionList.forEach((element: { questionSetId: number; isActive: boolean; }) => {
          if (element.questionSetId == questionSetId) {
            element.isActive = active ? false : true
          }
        });
      }
    }).catch((error) => {
    });
  }
}
